"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./section-header.less");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class SectionHeader extends _react.default.Component {
  render() {
    const {
      title,
      children
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "section-header"
    }, title && /*#__PURE__*/_react.default.createElement("h2", null, /*#__PURE__*/_react.default.createElement("a", {
      href: `#${encodeURIComponent(title).toLowerCase()}`
    }, title)), children);
  }
}
exports.default = SectionHeader;
//# sourceMappingURL=section-header.js.map